<template>
<div class="wh Detail content">
	<div class="detailtitle ofh relative">
		<!-- <span class="fleft worktabs">
			审核详情
		</span> -->
		<div class="textcenter">
			<span 
			v-for="(item,index) in tabData" 
			:key="index" 
			tag="span" 
			:class="['tabs',componentName == item.prop ? 'tabactive':'']"
				@click="tabsChange(item.prop)" style="height: 33px;">
				{{ item.label }}
			</span>
		</div>
	</div>
	<div>
		<component :datas="datas" v-bind:is="componentName"></component>
	</div>	
	<div style="height:80px;"></div>
	<div style="position: absolute;bottom: 0;left: 0;width: 100%;" class="p-operation-wrap">
        <el-button @click="$router.back()">返回</el-button>
        <el-button @click="dpms()">稿件下载</el-button>
		<el-button      
            @click="showBh()"
            v-if="info.check_status == 0">
            审核驳回
        </el-button>
        <el-button
            @click="showAh()"
            v-if="+info.check_status == 0">
            审核通过
        </el-button>
    </div>

	<component @close="closefn" :config="conf" v-bind:is="componentName2"></component>
</div>
</template>


<script>	
	import workData from './channel/info_work.vue'
	import reviewData from './channel/info_review.vue'
	import fileData from './channel/info_file.vue'
	import bh from './com/bh.vue'
	import tg from './com/tg.vue'
	export default {   
		
		components:{
			workData,
			reviewData,
			fileData,
			bh,
			tg
		},

		data() {
			return {
				componentName2:'',
				conf:{},
				componentName:'workData',
				tabData: [{
						label: "作品信息",prop:'workData'
					},
					{
						label: "交稿文件",prop:'fileData',
					},
					{
						label: "审核信息",prop:'reviewData'
					}
				],
				datas:{},
				list:[],

			}	
				
		},
		computed:{
			info(){
				return this.datas.check_info?this.datas.check_info.main_information:{}
			}
		},
		mounted(){
			this.getData();
		},
		methods: {
			closefn(n){
			
				if(n=='sx'){
					this.getData();
				}
				this.setCom2('')
			},
			showBh(){
				let {type,id} = this.$route.query;

				this.setCom2('bh',{type,id,title:'渠道分发审核驳回'})
			},
			showAh(){
				let {type,id} = this.$route.query;
				this.setCom2('tg',{type,id,title:'渠道分发审核通过',fileName:this.list[0].file_name})
			},
			setCom2(n,o){
				
				this.conf = o || {};
				this.componentName2 = n;
	
			},
			operationSuccess() {
				this.$router.back()
			},

			tabsChange(n){
				this.componentName = n;
			},
			getData(){
				let {type,id} = this.$route.query;
				this.api.reviewInfo({
					type,id
				}).then(da=>{
					this.datas = da;
					this.getDatafile()
	
				})
			},
			getDatafile(){
                let {check_info:{main_information:{channel_id}}} = this.datas;
                if(!channel_id){
                    return
                }
                this.api.channel_fileRecords({
                    channel_id:channel_id,
                }).then(da=>{
      
                    this.list = da.data; 
                })
            },
			dpms(){
				this.list.map(e=>{
					// if(e.check_status==1){
						this.download(e)
					// }
				})
			},
            download(row){	
                fetch(row.file_url).then(res => res.blob()).then(blob => {
                    const a = document.createElement('a');
                    document.body.appendChild(a)
                    a.style.display = 'none'
                    // 使用获取到的blob对象创建的url
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    // 指定下载的文件名
                    a.download = row.file_name;
                    a.click();
                    document.body.removeChild(a)
                    // 移除blob对象的url
                    window.URL.revokeObjectURL(url);
                });
            }
			
		},
	}
</script>

<style>

</style>

